import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueCompanyPageEvents, CompanyEventDetail } from '../../../types/companyDetail';

type Props = {
  id: number;
  coverNoImg: string;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageEvents;
  detail: CompanyEventDetail;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  coverNoImg,
  dataCategory,
  dataValue,
  detail,
}) => {
  const imageUrl =
    (detail.image && detail.image.url) ? detail.image.url : coverNoImg;

  return (
    <a
      href={`/events/${id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="company__page__recruitments__wrapper__item gtm-event-view-count"
      data-event-name='event on screen'
      data-event="click"
      data-category={dataCategory}
      data-value={dataValue.selfEvent}
    >
      <div className="company__page__recruitments__wrapper__item--cover">
        <img src={imageUrl} alt={`${detail.eventTitle || id} の画像`} />
      </div>
      <div className="company__page__recruitments__wrapper__item__box">
        <p className="company__page__recruitments__wrapper__item__box--occupation">
          {detail.startDate} ~ {detail.endDate}
        </p>
        <p className="company__page__recruitments__wrapper__item__box--occupation">
          {detail.eventLocation}
        </p>
        <p className="company__page__recruitments__wrapper__item__box--title">
          {detail.eventTitle}
        </p>
      </div>
    </a>
  );
};
